import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import brand1 from "../../../assets/images/brands/1.tataMyBistro.png";
import brand2 from "../../../assets/images/brands/2.Nescafe-Logo.jpg";
import brand3 from "../../../assets/images/brands/3.Tata Coffee.png";
import brand4 from "../../../assets/images/brands/4.Tata-Tea.png";
import brand5 from "../../../assets/images/brands/5.Tetley.png";
import brand6 from "../../../assets/images/brands/6.Ty_Phoo.jpeg";
import brand7 from "../../../assets/images/brands/7.bigbasket.png";
import brand8 from "../../../assets/images/brands/8.grabbit.png";
import brand9 from "../../../assets/images/brands/9.We-Vend.png";
import brand10 from "../../../assets/images/brands/10.offisoSanetory.png";
import brand11 from "../../../assets/images/brands/11.limpiar.png";
import brand12 from "../../../assets/images/brands/12.Kimberly-Clark_logo.png";
import brand13 from "../../../assets/images/brands/13.Diversey.png";
import brand14 from "../../../assets/images/brands/14.Dabur-Logo.wine.png";
import brand15 from "../../../assets/images/brands/15.gabbit first.png";
import brand16 from "../../../assets/images/brands/16.Odonil.png";
import brand17 from "../../../assets/images/brands/17.gala.png";
import brand18 from "../../../assets/images/brands/18.roots.png";
import brand19 from "../../../assets/images/brands/19.kangaro.png";
import brand20 from "../../../assets/images/brands/20.pidilite.png";
import brand21 from "../../../assets/images/brands/21.offisoPlant.png";
import brand22 from "../../../assets/images/brands/22.BOAT.jpg";
import brand23 from "../../../assets/images/brands/23.Britannia Industries-01.png";
import brand24 from "../../../assets/images/brands/24.Parle.png";
import brand25 from "../../../assets/images/brands/25.haldirams-logo.png";
import brand26 from "../../../assets/images/brands/26.Open Secret.png";
import brand27 from "../../../assets/images/brands/27.rebel foods.jpeg";
import brand28 from "../../../assets/images/brands/28.maggi.png";
import brand29 from "../../../assets/images/brands/29.Lays.png";
import brand30 from "../../../assets/images/brands/30.Kitkat.png";
import brand31 from "../../../assets/images/brands/31.Bailley.png";
import brand32 from "../../../assets/images/brands/32.tata copper water.png";

const brandImages = [
    brand1, brand2, brand3, brand4, brand5, brand6, brand7, brand8, brand9, brand10,
    brand11, brand12, brand13, brand14, brand15, brand16, brand17, brand18, brand19, brand20,
    brand21, brand22, brand23, brand24, brand25, brand26, brand27, brand28, brand29, brand30, 
    brand31, brand32
];

const Brands = () => {
    return (
        <React.Fragment>
            <div className="pt-4 mt-5">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center ">
                                <h5 className="fs-20 fw-bold">Associated Brands</h5>
                                <Swiper
                                    slidesPerView={6}
                                    spaceBetween={30}

                                    pagination={false}
                                    breakpoints={{
                                        576: { slidesPerView: 3 },
                                        768: { slidesPerView: 4 },
                                        1024: { slidesPerView: 6 },
                                    }}
                                    loop={true}
                                    autoplay={{ delay: 1000, disableOnInteraction: false }}
                                    modules={[Pagination, Autoplay]}
                                    className="mySwiper swiper trusted-client-slider mt-sm-5 mt-4 mb-sm-5 "
                                >
                                    {brandImages.map((brand, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="client-images d-flex justify-content-center align-item" style={{ width: "100%", height:"100%"}}>
                                                <img src={brand} alt={`brand-${index + 1}`} className="img-fluid" style={{ width: "400px", height: "350px", objectFit: "contain"}}/>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Brands;